import m from "mithril"

export default {
  view: function () {
    return m("div.empty-state", [
      m("svg", { width: 64, height: 64, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 1.5 }, [
        m("circle", { cx: 11, cy: 11, r: 8 }),
        m("path", { d: "m21 21-4.35-4.35" }),
      ]),
      m("h3", "No projects found"),
      m("p", "Try adjusting your filters to find what you're looking for."),
    ])
  },
}
